import { render, staticRenderFns } from "./my_advances.vue?vue&type=template&id=db441466&"
import script from "./my_advances.vue?vue&type=script&lang=js&"
export * from "./my_advances.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports